import { useContext, useState, useEffect } from 'react';

import {
  CENTRY,
  MULTIVENDE,
  PIM,
  YUJU,
  STARKOMS,
  PRODUCTECA,
  ECOMEXPERTS,
  ECOMSUR,
  ASTROSELLING,
  RELBASE,
} from 'variables/sellerTypes';
import SessionContext from 'api/session/context';
import { trackGTMEventActionTourGuide } from 'utils/analytics';
import {
  SellerPublishedIntegrated,
  SellerPublishedPim,
  SellerNotPublished,
  SelleMultiCentryNoPublishedTour,
} from 'utils/tourguide';
import { updateStatusTourGuide } from 'api/tourguide';

export function useTourSteps() {
  const changeReguest = localStorage.getItem('_change_request');
  const firstTimeTour = localStorage.getItem('firstTimeTour');
  const [enableTourGuide, setEnableTourGuide] = useState(false);
  const [isTourGuide, setIsTourGuide] = useState(false);
  const [componentLoad, setComponentLoad] = useState(false);

  const {
    auth: { sellerType, sellerIsInPublishHistory, sellerName, jwt, terms, statusCompleteTourGuide },
  } = useContext(SessionContext);

  useEffect(async () => {
    setTimeout(async () => {
      if (changeReguest === null || changeReguest === undefined || changeReguest.isEmpty()) {
        if (firstTimeTour === '0') {
          if (!Array.isArray(terms) || !terms.length) {
            if (
              [
                CENTRY,
                MULTIVENDE,
                PIM,
                YUJU,
                STARKOMS,
                PRODUCTECA,
                ECOMEXPERTS,
                ECOMSUR,
                ASTROSELLING,
                RELBASE,
              ].includes(sellerType) &&
              !statusCompleteTourGuide
            ) {
              setEnableTourGuide(true);
              setComponentLoad(true);
            }
          } else {
            if (
              [
                CENTRY,
                MULTIVENDE,
                PIM,
                YUJU,
                STARKOMS,
                PRODUCTECA,
                ECOMEXPERTS,
                ECOMSUR,
                ASTROSELLING,
                RELBASE,
              ].includes(sellerType) &&
              !statusCompleteTourGuide
            ) {
              setEnableTourGuide(false);
              setComponentLoad(false);
            }
          }
        }
      }
    }, 1000);
  }, [firstTimeTour]);

  const getTourGuideConfiguration = () => {
    if ([PIM].includes(sellerType) && !sellerIsInPublishHistory) {
      return SellerNotPublished;
    }
    if (
      [CENTRY, MULTIVENDE, YUJU, STARKOMS, PRODUCTECA, ECOMEXPERTS, ECOMSUR, RELBASE, ASTROSELLING].includes(
        sellerType,
      ) &&
      !sellerIsInPublishHistory
    ) {
      return SelleMultiCentryNoPublishedTour;
    }
    if (
      [CENTRY, MULTIVENDE, YUJU, STARKOMS, PRODUCTECA, ECOMEXPERTS, ECOMSUR, RELBASE, ASTROSELLING].includes(
        sellerType,
      ) &&
      sellerIsInPublishHistory
    ) {
      return SellerPublishedIntegrated;
    }
    if ([PIM].includes(sellerType) && sellerIsInPublishHistory) {
      return SellerPublishedPim;
    }

    return {};
  };

  const getTourSteps = () => {
    const { steps } = getTourGuideConfiguration();
    return steps;
  };

  const onLaunchTourGuide = () => {
    trackGTMEventActionTourGuide({
      action: 'Clic en botón Guia de uso',
      category: 'Interacciones Tour Guide',
      tag: sellerName,
    });
    setEnableTourGuide(!enableTourGuide);
    setComponentLoad(!enableTourGuide);
  };

  const onFinishTourGuide = async () => {
    setIsTourGuide(!isTourGuide);
    setEnableTourGuide(!enableTourGuide);
    setComponentLoad(!enableTourGuide);
    await updateStatusTourGuide(jwt, sellerId, 1);
  };

  return {
    getTourSteps,
    onLaunchTourGuide,
    onFinishTourGuide,
    enableTourGuide,
    isTourGuide,
    componentLoad,
    getTourGuideConfiguration,
    setEnableTourGuide,
    setIsTourGuide,
    setComponentLoad,
  };
}
